import { render } from "./WalletBuyPartialStep.vue?vue&type=template&id=5057c118"
import script from "./WalletBuyPartialStep.vue?vue&type=script&lang=js"
export * from "./WalletBuyPartialStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__